<template>
  <v-tour :name="name" :callbacks="callbacks" :steps="steps" :options="options">
    <template slot-scope="tour">
      <transition-group name="fade">
        <div
          v-for="(step, index) of tour.steps"
          :key="index + ' ' + step.header"
        >
          <v-step
            v-if="tour.currentStep === index"
            :class="`tour-${name}-step-${index}`"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="tour.highlight"
          >
            <template>
              <div slot="actions">
                <div class="v-step__buttons">
                  <button
                    v-if="!tour.isFirst"
                    @click="tour.previousStep"
                    class="v-step__button v-step__button-previous"
                  >
                    &lt; <span class="button-text">Previous</span>
                  </button>
                  <span v-else></span>
                  <button
                    v-if="!tour.isLast"
                    @click="tour.nextStep"
                    class="v-step__button v-step__button-next"
                  >
                    <span class="button-text">Next</span> &gt;
                  </button>
                  <button
                    v-if="!tour.isLast"
                    @click="tour.stop"
                    class="v-step__button v-step__button-stop"
                  >
                    &times;
                  </button>
                  <button
                    v-if="tour.isLast"
                    @click="tour.stop"
                    class="v-step__button v-step__button-exit"
                  >
                    <span class="button-text">End</span>
                  </button>
                </div>
              </div>
            </template>
          </v-step>
        </div>
      </transition-group>
    </template>
  </v-tour>
</template>

<script>
export default {
  name: "Tour",
  props: {
    callbacks: Object,
    enabled: Boolean,
    name: String,
    options: Object,
    steps: Array
  },
  watch: {
    enabled(to) {
      if (to) {
        this.$tours[this.name].start();
      } else {
        this.$tours[this.name].stop();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/constants/_variables.scss";

#app {
  .v-tour__target--highlighted {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
    z-index: 9999;
  }

  .v-tour .v-step {
    background: #fffaf1;
    border-radius: 0;
    color: #000000;
    filter: none;
    padding: 0.75rem;
    text-align: left;

    &__arrow {
      display: none;
    }

    &__buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &__button {
      border: none;
      color: #c04323;
      font-size: 0.9em;
      font-weight: 400;
      height: 1.2rem;
      padding: 0;
      text-transform: uppercase;

      .button-text {
        text-decoration: underline;
      }

      &:hover {
        color: $dark-red;
        background: transparent;
      }

      &-stop {
        color: #ccc;
        font-size: 2em;
        font-weight: 300;
        margin: 0;
        position: absolute;
        right: 0.75rem;
        text-decoration: none;
        top: 0.75rem;

        &:hover {
          color: $brown-grey;
        }
      }
    }

    &__header {
      background: #fffaf1;
      color: #c04323;
      font-size: 1.1em;
      font-weight: 500;
      margin: unset;
      margin-bottom: 0.5rem;
      padding: 0;
    }

    &__content {
      a {
        color: black;
      }
    }
  }
}
</style>
